<template>
    <div class="gpt-chart-table">
        <table>
            <thead>
            </thead>
            <tbody>
                <tr v-for="(record, idx) in value" :key="idx">
                    <td v-for="(cell, key, idx) in record" :key="key + idx">
                        {{cell}}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'gpt-chart-table',
    data () {
        return { };
    },
    props: {
        value: {
            type: Array,
            default: null
        }
    }
};
</script>
<style scoped lang="scss">
.gpt-chart-table {
    position: relative;
    width: 100%;
    max-height: 30em;
    overflow: auto;
}
</style>
